(function () {
  'use strict';

  if (window.PrewornDemandSignalsLoaded) return;
  window.PrewornDemandSignalsLoaded = true;

  var API_URL = 'https://preworn.co.uk/sandbox/shopify-catalog-index/preworn_demand_api.php';
  var WISHLIST_KEY = 'preworn:wishlist';
  var CLIENT_KEY = 'preworn:demand-client';
  var SYNC_KEY = 'preworn:demand-sync-v2';
  var WISHLIST_THRESHOLD = 3;
  var BASKET_THRESHOLD = 2;
  var CACHE_MS = 60000;
  var WISHLIST_RESYNC_MS = 24 * 60 * 60 * 1000;
  var BASKET_RESYNC_MS = 15 * 60 * 1000;
  var cache = {};
  var lastSynced = { wishlist: null, basket: null };
  var previousHandles = { wishlist: [], basket: [] };
  var refreshTimer = null;
  var syncTimers = {};
  var observer = null;
  var hadAnalyticsConsent = false;
  var initialSyncScheduled = false;
  var clientCreatedThisPage = false;
  var emptyWithoutClient = { wishlist: false, basket: false };

  function automatedClient() {
    var userAgent = window.navigator && window.navigator.userAgent
      ? window.navigator.userAgent : '';
    return /bot(?:\/|\b)|crawler|spider|slurp|bingpreview|facebookexternalhit|meta-externalagent|tiktokspider|bytespider|applebot|amazonbot|semrush|ahrefs|mj12bot|petalbot|yandexbot|duckduckbot|baiduspider|gptbot|chatgpt-user|claudebot|perplexitybot/i.test(userAgent);
  }

  function uniqueHandles(values) {
    var seen = {};
    var handles = [];
    (values || []).forEach(function (value) {
      var handle = String(value || '').trim().toLowerCase();
      if (!/^[a-z0-9][a-z0-9-]{0,254}$/.test(handle) || seen[handle]) return;
      seen[handle] = true;
      handles.push(handle);
    });
    return handles;
  }

  function handleFromUrl(value) {
    var match = String(value || '').match(/\/products\/([^/?#]+)/i);
    if (!match) return '';
    try {
      return decodeURIComponent(match[1]).toLowerCase();
    } catch (error) {
      return String(match[1] || '').toLowerCase();
    }
  }

  function wishlistHandles() {
    try {
      var stored = window.localStorage.getItem(WISHLIST_KEY);
      var items = stored ? JSON.parse(stored) : [];
      if (!Array.isArray(items)) return [];
      return uniqueHandles(items.map(function (item) {
        return item && (item.handle || handleFromUrl(item.url));
      }));
    } catch (error) {
      return [];
    }
  }

  function cartHandles(cart) {
    var items = cart && Array.isArray(cart.items) ? cart.items : [];
    return uniqueHandles(items.map(function (item) {
      return item && (item.handle || handleFromUrl(item.url));
    }));
  }

  function analyticsAllowed() {
    try {
      return !!(
        window.Shopify &&
        window.Shopify.customerPrivacy &&
        typeof window.Shopify.customerPrivacy.analyticsProcessingAllowed === 'function' &&
        window.Shopify.customerPrivacy.analyticsProcessingAllowed()
      );
    } catch (error) {
      return false;
    }
  }

  function randomClientId() {
    if (window.crypto && typeof window.crypto.randomUUID === 'function') {
      return window.crypto.randomUUID();
    }
    if (window.crypto && typeof window.crypto.getRandomValues === 'function') {
      var values = new Uint8Array(16);
      window.crypto.getRandomValues(values);
      values[6] = (values[6] & 15) | 64;
      values[8] = (values[8] & 63) | 128;
      var hex = Array.prototype.map.call(values, function (value) {
        return value.toString(16).padStart(2, '0');
      }).join('');
      return hex.slice(0, 8) + '-' + hex.slice(8, 12) + '-' + hex.slice(12, 16) + '-' +
        hex.slice(16, 20) + '-' + hex.slice(20);
    }
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (character) {
      var value = Math.floor(Math.random() * 16);
      return (character === 'x' ? value : (value & 3) | 8).toString(16);
    });
  }

  function clientId(create) {
    try {
      var stored = window.localStorage.getItem(CLIENT_KEY) || '';
      if (stored || !create) return stored;
      stored = randomClientId();
      // A new identifier must never inherit sync metadata from an old one.
      window.localStorage.removeItem(SYNC_KEY);
      window.localStorage.setItem(CLIENT_KEY, stored);
      clientCreatedThisPage = true;
      Object.keys(emptyWithoutClient).forEach(function (kind) {
        if (emptyWithoutClient[kind]) rememberSync(kind, '');
      });
      return stored;
    } catch (error) {
      return '';
    }
  }

  function readSyncState() {
    try {
      var stored = window.localStorage.getItem(SYNC_KEY);
      var state = stored ? JSON.parse(stored) : {};
      return state && typeof state === 'object' ? state : {};
    } catch (error) {
      return {};
    }
  }

  function writeSyncState(state) {
    try {
      window.localStorage.setItem(SYNC_KEY, JSON.stringify(state || {}));
    } catch (error) {}
  }

  function rememberSync(kind, signature) {
    var state = readSyncState();
    state[kind] = {
      signature: signature,
      syncedAt: Date.now()
    };
    writeSyncState(state);
  }

  function recentlySynced(kind, signature) {
    var record = readSyncState()[kind];
    if (!record || record.signature !== signature) return false;
    var maximumAge = kind === 'basket' ? BASKET_RESYNC_MS : WISHLIST_RESYNC_MS;
    return Date.now() - (Number(record.syncedAt) || 0) < maximumAge;
  }

  function previouslySyncedHandles(kind) {
    var record = readSyncState()[kind];
    return record && record.signature
      ? uniqueHandles(String(record.signature).split(',')) : [];
  }

  function post(payload) {
    return window.fetch(API_URL + '?action=' + encodeURIComponent(payload.action || 'sync'), {
      method: 'POST',
      mode: 'cors',
      credentials: 'omit',
      keepalive: true,
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(payload)
    }).then(function (response) {
      if (!response.ok) throw new Error('Demand signal request failed');
      return response.json();
    });
  }

  function invalidate(handles) {
    uniqueHandles(handles).forEach(function (handle) {
      delete cache[handle];
    });
  }

  function syncState(kind, handles) {
    if (!analyticsAllowed()) return Promise.resolve(false);
    hadAnalyticsConsent = true;
    handles = uniqueHandles(handles);

    // Empty state from a new visitor should not create an ID or call PHP.
    var id = clientId(false);
    if (!handles.length && !id) {
      emptyWithoutClient[kind] = true;
      lastSynced[kind] = '';
      previousHandles[kind] = [];
      return Promise.resolve(false);
    }
    if (!handles.length && clientCreatedThisPage && !readSyncState()[kind]) {
      rememberSync(kind, '');
      lastSynced[kind] = '';
      previousHandles[kind] = [];
      return Promise.resolve(false);
    }
    if (!id) id = clientId(true);
    if (!id) return Promise.resolve(false);

    var signature = handles.slice().sort().join(',');
    if (lastSynced[kind] === signature) return Promise.resolve(false);
    var affected = uniqueHandles(
      (previousHandles[kind] || []).concat(previouslySyncedHandles(kind), handles)
    );
    previousHandles[kind] = handles.slice();

    // Carry sync decisions across Shopify page navigations. Basket state is
    // refreshed regularly; unchanged wishlist state needs only a daily touch.
    if (recentlySynced(kind, signature)) {
      lastSynced[kind] = signature;
      return Promise.resolve(false);
    }
    lastSynced[kind] = signature;

    return post({
      action: 'sync',
      sessionId: id,
      kind: kind,
      handles: handles
    }).then(function () {
      rememberSync(kind, signature);
      invalidate(affected);
      scheduleRefresh(150);
      return true;
    }).catch(function () {
      lastSynced[kind] = null;
      return false;
    });
  }

  function scheduleSync(kind, handles, delay) {
    window.clearTimeout(syncTimers[kind]);
    syncTimers[kind] = window.setTimeout(function () {
      syncState(kind, handles);
    }, typeof delay === 'number' ? delay : 250);
  }

  function fetchCartAndSync() {
    if (!analyticsAllowed()) return;
    var root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root
      ? window.Shopify.routes.root : '/';
    window.fetch(root + 'cart.js', {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' }
    }).then(function (response) {
      if (!response.ok) throw new Error('Cart unavailable');
      return response.json();
    }).then(function (cart) {
      scheduleSync('basket', cartHandles(cart), 0);
    }).catch(function () {});
  }

  function syncAll() {
    if (!analyticsAllowed()) return;
    hadAnalyticsConsent = true;
    scheduleSync('wishlist', wishlistHandles(), 0);
    fetchCartAndSync();
  }

  function scheduleInitialSync() {
    if (initialSyncScheduled) return;
    initialSyncScheduled = true;
    var run = function () {
      initialSyncScheduled = false;
      syncAll();
    };
    if (typeof window.requestIdleCallback === 'function') {
      window.requestIdleCallback(run, { timeout: 3000 });
    } else {
      window.setTimeout(run, 1500);
    }
  }

  function forgetSession() {
    var id = clientId(false);
    try {
      window.localStorage.removeItem(CLIENT_KEY);
      window.localStorage.removeItem(SYNC_KEY);
    } catch (error) {}
    lastSynced = { wishlist: null, basket: null };
    previousHandles = { wishlist: [], basket: [] };
    clientCreatedThisPage = false;
    emptyWithoutClient = { wishlist: false, basket: false };
    if (!id) return;
    post({ action: 'forget', sessionId: id }).catch(function () {});
  }

  function makeMarker(handle, context) {
    var marker = document.createElement('div');
    marker.className = 'pwdemand-slot pwdemand-slot--' + context;
    marker.setAttribute('data-pw-demand', '');
    marker.setAttribute('data-product-handle', handle);
    marker.setAttribute('data-pw-demand-context', context);
    marker.hidden = true;
    return marker;
  }

  function ensureMarkers(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var buttons = scope.querySelectorAll('[data-pw-add-cart][data-product-handle]');
    for (var i = 0; i < buttons.length; i++) {
      var button = buttons[i];
      var handle = String(button.getAttribute('data-product-handle') || '').toLowerCase();
      if (!handle) continue;
      var card = button.closest('.pw-card, .card-wrapper, .product-card-wrapper, .grid__item');
      if (!card || card.querySelector('[data-pw-demand]')) continue;
      var body = card.querySelector('.pw-card__body, .card__information, .card-information');
      if (body) body.appendChild(makeMarker(handle, 'card'));
    }

    if (/\/products\//i.test(window.location.pathname) && !document.querySelector('[data-pw-demand-context="product"]')) {
      var productHandle = handleFromUrl(window.location.pathname);
      var productForm = document.querySelector('product-form, form[action*="/cart/add"]');
      if (productHandle && productForm && productForm.parentNode) {
        productForm.parentNode.insertBefore(makeMarker(productHandle, 'product'), productForm);
      }
    }
  }

  function signalMarkup(wishlists, baskets) {
    var parts = [];
    if (wishlists >= WISHLIST_THRESHOLD) {
      parts.push('<strong>' + wishlists + '</strong> ' + (wishlists === 1 ? 'save' : 'saves'));
    }
    if (baskets >= BASKET_THRESHOLD) {
      parts.push('in <strong>' + baskets + '</strong> baskets');
    }
    return parts.join('<span aria-hidden="true"> · </span>');
  }

  function renderMarker(marker, counts) {
    var context = marker.getAttribute('data-pw-demand-context') || 'card';
    if (context === 'product' && marker.getAttribute('data-product-available') === 'false') {
      marker.innerHTML = '';
      marker.hidden = true;
      return;
    }
    var wishlists = Math.max(0, Number(counts && counts.wishlists) || 0);
    var baskets = Math.max(0, Number(counts && counts.baskets) || 0);
    var markup = signalMarkup(wishlists, baskets);

    if (!markup && context === 'product') {
      marker.classList.add('pwdemand-slot--fallback');
      marker.innerHTML = '<span class="pwdemand-slot__pulse" aria-hidden="true"></span>' +
        '<span><strong>One-off piece</strong> — it is not reserved until checkout.</span>';
      marker.hidden = false;
      return;
    }

    marker.classList.remove('pwdemand-slot--fallback');
    marker.innerHTML = markup
      ? '<span class="pwdemand-slot__pulse" aria-hidden="true"></span><span>' + markup + '</span>'
      : '';
    marker.hidden = !markup;
  }

  function markerHandles() {
    var handles = [];
    var markers = document.querySelectorAll('[data-pw-demand][data-product-handle]');
    for (var i = 0; i < markers.length; i++) {
      handles.push(markers[i].getAttribute('data-product-handle'));
    }
    return uniqueHandles(handles);
  }

  function renderKnown() {
    var now = Date.now();
    var markers = document.querySelectorAll('[data-pw-demand][data-product-handle]');
    for (var i = 0; i < markers.length; i++) {
      var handle = String(markers[i].getAttribute('data-product-handle') || '').toLowerCase();
      if (cache[handle] && now - cache[handle].storedAt < CACHE_MS) {
        renderMarker(markers[i], cache[handle]);
      }
    }
  }

  function fetchCounts(handles) {
    handles = uniqueHandles(handles);
    if (!handles.length) return Promise.resolve({});
    var url = API_URL + '?action=counts&handles=' + encodeURIComponent(handles.join(','));
    return window.fetch(url, {
      mode: 'cors',
      credentials: 'omit',
      cache: 'no-store',
      headers: { Accept: 'application/json' }
    }).then(function (response) {
      if (!response.ok) throw new Error('Demand counts unavailable');
      return response.json();
    }).then(function (payload) {
      return payload && payload.counts ? payload.counts : {};
    });
  }

  function refreshSignals() {
    ensureMarkers(document);
    var handles = markerHandles();
    var now = Date.now();
    var missing = handles.filter(function (handle) {
      return !cache[handle] || now - cache[handle].storedAt >= CACHE_MS;
    });
    renderKnown();
    if (!missing.length) return;

    var batches = [];
    while (missing.length) batches.push(missing.splice(0, 50));
    Promise.all(batches.map(fetchCounts)).then(function (responses) {
      var storedAt = Date.now();
      batches.forEach(function (batch, index) {
        var counts = responses[index] || {};
        batch.forEach(function (handle) {
          var value = counts[handle] || {};
          cache[handle] = {
            wishlists: Number(value.wishlists) || 0,
            baskets: Number(value.baskets) || 0,
            storedAt: storedAt
          };
        });
      });
      renderKnown();
    }).catch(function () {
      var productMarker = document.querySelector('[data-pw-demand-context="product"]');
      if (productMarker) renderMarker(productMarker, null);
    });
  }

  function scheduleRefresh(delay) {
    window.clearTimeout(refreshTimer);
    refreshTimer = window.setTimeout(refreshSignals, typeof delay === 'number' ? delay : 80);
  }

  function initialisePrivacy() {
    if (analyticsAllowed()) {
      scheduleInitialSync();
      return;
    }
    if (window.Shopify && typeof window.Shopify.loadFeatures === 'function') {
      window.Shopify.loadFeatures([
        { name: 'consent-tracking-api', version: '0.1' }
      ], function () {
        if (analyticsAllowed()) {
          scheduleInitialSync();
        } else if (clientId(false)) {
          forgetSession();
        }
      });
    }
  }

  function initialise() {
    if (automatedClient()) return;
    refreshSignals();
    initialisePrivacy();

    window.addEventListener('preworn:wishlist-change', function () {
      scheduleSync('wishlist', wishlistHandles());
    });
    window.addEventListener('preworn:cart-change', function (event) {
      if (event.detail && event.detail.cart) {
        scheduleSync('basket', cartHandles(event.detail.cart));
      }
    });
    window.addEventListener('preworn:cart-toggle', function (event) {
      if (event.detail && event.detail.cart) {
        scheduleSync('basket', cartHandles(event.detail.cart));
      }
    });
    document.addEventListener('shopify:cart:lines-update', function () {
      fetchCartAndSync();
    });
    window.addEventListener('storage', function (event) {
      if (event.key === WISHLIST_KEY) scheduleSync('wishlist', wishlistHandles());
    });
    document.addEventListener('visitorConsentCollected', function () {
      if (analyticsAllowed()) {
        scheduleInitialSync();
      } else if (hadAnalyticsConsent) {
        hadAnalyticsConsent = false;
        forgetSession();
      }
    });

    if (typeof window.MutationObserver === 'function') {
      observer = new MutationObserver(function (mutations) {
        for (var i = 0; i < mutations.length; i++) {
          var nodes = mutations[i].addedNodes || [];
          for (var j = 0; j < nodes.length; j++) {
            var node = nodes[j];
            if (node.nodeType !== 1) continue;
            if (
              (node.matches && node.matches('.pw-card, .card-wrapper, .product-card-wrapper, [data-pw-demand]')) ||
              (node.querySelector && node.querySelector('.pw-card, .card-wrapper, .product-card-wrapper, [data-pw-demand]'))
            ) {
              scheduleRefresh();
              return;
            }
          }
        }
      });
      observer.observe(document.body, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialise);
  } else {
    initialise();
  }
})();
